// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609251821/js/" + chunkId + "." + {"44":"099e37ee","225":"f595609c","481":"172a9bfc","486":"0401ea96","770":"f0e0d459"}[chunkId] + ".0.2759904060095917.chunk.js";
};